export enum PlanningRefreshSource{
    LeftDateChange = "LeftDateChange",
    RightDateChange = "RightDateChange",
    TodayDateChange = "TodayDateChange",
    PointDateChange = "PointDateChange",
    DayModelChange = "timeGridDaytimeGridDayday",
    WeekModelChange = "timeGridWeekweek",
    DoctorChange = "DoctorChange",
    DoctorChangeList = "DoctorChangeList",
    InitiationChange = "InitiationChange",
    DayModelInit = "timeGridDayday",
    PatientChange = "selectPatient",
    AppointmentTypeChange = "selectAppointmentType",
    WeekAgendaTypeChangeModifier = "week",
    DayAgendaTypeChangeModifier = "day"
}